<template>
    <div class="position-box">
        <div class="head">
            <div class="back-box" @click="goBack"><img class="icon" src="@/assets/icon_back.png" alt="back"></div>
            <div>{{this.$t('wdyj.title')}}</div>
        </div>
        <div class="cont-box">
            <vue-better-scroll class="wrapper"
                ref="scroll"
                :scrollbar="scrollbarObj"
                :pullDownRefresh="pullDownRefreshObj"
                :pullUpLoad="pullUpLoadObj"
                :startY="parseInt(startY)"
                :probeType="1"
                :listenScroll=true
                @scroll="scroll"
                @pulling-down="onPullingDown"
                @pulling-up="onPullingUp">
                <ul class="item-box">
                    <li class="item item1">
                        <div class="text">{{this.$t('wdyj.tdzyj')}}</div>
                        <div class="item-num">
                            <div><span v-if="!isShow">******</span><span v-else>{{totalYj}}<span class="small"> T</span></span></div>
                            <img class="icon" src="@/assets/icon_show.png" v-show="isShow" @click.stop="change" alt="">
                            <img class="icon" src="@/assets/icon_hide.png" v-show="!isShow" @click.stop="change" alt="">
                        </div>
                    </li>
                </ul>
                <div class="title">{{this.$t('wdyj.wdyd')}}</div>
                <div class="list-bg">
                    <ul class="ul-box">
                        <li class="list">
                            <div class="list-item">
                                <div class="text">{{$t('wdyj.uid')}}<span class="cont">1111</span></div>
                                <div class="text mt26">{{$t('wdyj.tdrs')}}<span class="cont">5</span></div>
                            </div>
                            <div class="text">{{$t('wdyj.yj')}}<span class="cont">0.5 T</span></div>
                        </li>
                    </ul>
                    <img class="go-top" src="@/assets/top.png" alt="" @click="scrollTo" v-show="isTop">
                </div>
            <no-data v-show="hasData"></no-data>
            </vue-better-scroll>
        </div>
    </div>

</template>

<script>
import noData from '@/components/noData.vue'
import VueBetterScroll from 'vue2-better-scroll'

export default {
    name: 'index',
    data () {
        return {
            curIdx: 0,
            uid: '',
            token: '',
            region_cp_num: 0,
            commiunity_cp_num: 0,
            own_cp_num: 0,
            totalYj: 0,
            wdyjUid: [],
            listData: [],
            isShow: false,
            hasData: false,
            isTop: false,
            scrollbarObj: {
                fade: true
            },
             // 这个配置用于做下拉刷新功能，默认为 false。当设置为 true 或者是一个 Object 的时候，可以开启下拉刷新，可以配置顶部下拉的距离（threshold） 来决定刷新时机以及回弹停留的距离（stop）
            pullDownRefreshObj: {
                threshold: 90,
                stop: 40,
                txt: this.$t('tips.sxcg')
            },
            // 这个配置用于做上拉加载功能，默认为 false。当设置为 true 或者是一个 Object 的时候，可以开启上拉加载，可以配置离底部距离阈值（threshold）来决定开始加载的时机
            pullUpLoadObj: {
                threshold: 0,
                txt: {
                    more: this.$t('tips.jzgd'),
                    noMore: this.$t('tips.mygdsjl')
                }
            },
            startY: 0, // 纵轴方向初始化位置
            scrollToY: 0,
            scrollToTime: 500,
            page: 1,
            limit: 10
        }
    },
    created(){
        let uid = this.uid = localStorage.getItem('uid');
        let token = this.token = localStorage.getItem('token');
        let yjShow = localStorage.getItem('yjShow');
        if(yjShow == null || yjShow == 'true'){
            localStorage.setItem('yjShow',true);
            this.isShow = true
        }else{
            localStorage.setItem('yjShow',false);
            this.isShow = false
        }
    },
    mounted() {
        this.getGroupInfo();
        this.init()
    },
    methods: {
        getGroupInfo(){
            let params = {
                uid: this.uid,
                token: this.token
            }
            this.$ajax.post('/api/member/getGroupInfo',params).then((res) => {
                let resData = res.data.data;
                if(res.data.code == 200){
                    this.region_cp_num = resData.region_cp_num;
                    this.commiunity_cp_num = resData.commiunity_cp_num;
                    this.own_cp_num = resData.own_cp_num;
                    this.totalYj = parseFloat(resData.region_cp_num) + parseFloat(resData.commiunity_cp_num) + parseFloat(resData.own_cp_num)
                }else{
                    this.$toast.bottom(res.data.msg);
                }
            }).catch(function(err){
                console.log(err);
            })
        },
        init(){
            let params = {
                uid: this.uid,
                token: this.token,
                limit: this.limit,
                page: this.page
            }
            this.$ajax.post('/api/member/getChildCp',params).then((res) => {
                let resData = res.data.data;
                if(res.data.code == 200){
                     if(resData.length > 0){
                        this.hasData = false
                        this.listData = resData;
                        this.$refs.scroll.forceUpdate(true)
                    }else{
                        this.hasData = true;
                    }
                }else{
                    this.$toast.bottom(res.data.msg);
                }
            }).catch(function(err){
                console.log(err);
            })
        },
         /* 下拉刷新的回调 */
        onPullingDown () {
            this.listData = [];
            this.page = 1;
            this.init()
        },
        /* 上拉加载 */
        onPullingUp(){
            this.page ++;
            let params = {
                uid: this.uid,
                token: this.token,
                limit: this.limit,
                page: this.page
            }
            this.$ajax.post('/api/member/getChildCp',params).then((res) => {
                let resData = res.data.data;
                if(res.data.code == 200){
                    if(resData.length > 0){
                        this.listData = this.listData.concat(resData);
                        this.$refs.scroll.forceUpdate(true)
                    }else{
                         this.$refs.scroll.forceUpdate(false)
                    }
                }else{
                    this.$toast.bottom(res.data.msg);
                }
            }).catch(function(err){
                console.log(err);
            })
        },
        scroll({x, y}){
            if(Math.abs(y) >= 300){
                this.isTop = true;
            }else{
                this.isTop = false
            }
        },
        // 滚动到页面顶部
        scrollTo() {
            this.$refs.scroll.scrollTo(this.scrollToY, this.scrollToTime)
        },
        jump(id,people){
            if(people > 0){
                this.wdyjUid.push(id);
                let wdyjUid = JSON.stringify(this.wdyjUid);
                localStorage.setItem('wdyjUid',wdyjUid);
                this.$router.push({name:'wdyjChild',params:{id:id}});
            }

        },
        change(){
            this.isShow = !this.isShow;
            localStorage.setItem('yjShow',this.isShow)
        },
        goBack(){
            this.$router.go(-1)
        }
    },
    components:{
        noData,
        VueBetterScroll
    }
}
</script>
<style scoped>
    .position-box{
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 100%;
        height: auto;
        color: #cecece;
        font-size: .36rem;
        background: url('../assets/element-background.png') no-repeat center center;
        background-size: cover;
        overflow: hidden;
    }
    .head{
        position: fixed;
        top: 0;
        z-index: 999;
        width: 100%;
        height: 1.2rem;
        font-size: .52rem;
        line-height: 1.2rem;
        /* background: #0E1530; */
        text-align: center;
    }
    .head .icon{
        position: absolute;
        left: .3rem;
        top: .3rem;
        width: .32rem;
        height: .6rem;
    }
    .head .invite{
        position: absolute;
        right: .3rem;
        top: 0;
        color: #fff;
        font-size: .45rem;
    }
    .cont-box{
        position: absolute;
        left: .24rem;
        right: .24rem;
        top: 1.2rem;
        bottom: 0;
        width: auto;
        height: auto;
        color: #cecece;
        font-size: .36rem;
        /* background: #0E1530;  */
        box-sizing: border-box;
        overflow: hidden;
    }
    .num{
        padding: .4rem 0 .24rem;
        color: #00FFD8;
        font-size: .8rem;
        text-align: center;
    }
    .num .small{
        font-size: .45rem;
    }
    .num-text{
        color: #c4c4c4;
        font-size: .36rem;
        text-align: center;
    }
    .item-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: .3rem;
        padding: .4rem .56rem .56rem;
        background: linear-gradient(90deg,  rgba(43, 153, 147, 0.5), rgba(0, 255, 241, 0.2));
        border-radius: .1rem;
    }
    .item-box .icon{
        width: .6rem;
    }
    .item-box .item{
        flex: 1;
    }
    .item-box .item .item-num{
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-top: .16rem;
        font-size: .8rem;
    }
    .item-box .item .item-num .small{
        font-size: .45rem;
    }
    .item-box .item .text{
        color: #c4c4c4;
        font-size: .36rem;
    }
    .title{
        padding: .36rem 0;
        color: #fff;
        font-size: .45rem;
    }
    /* .list-bg{
        position: absolute;
        left: 0;
        right: 0;
        height: 7rem;
        overflow: hidden;
    } */
    /* .ul-box{
        padding: 0 0 .4rem;
    } */
    .ul-box .list{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: .22rem;
        padding: .32rem .42rem .3rem .32rem;
        background: rgba(4, 9, 37,.5);
        border-radius: .1rem;
    }
    .ul-box .list .text{
        color: #c4c4c4;
        font-size: .24rem;
    }
    .ul-box .list .list-item .mt26{
        margin-top: .26rem;
    }
    .ul-box .list .cont{
        color: #fff;
        font-size: .24rem;
    }
    .ul-box .list .list-item-foot{
        padding-top: .26rem;
    }
</style>



// WEBPACK FOOTER //
// src/pages/wdyj.vue